import * as entityActions from '../actions/entityActions';
import entityResource from './entityReducer';

export default function entitiesReducer(state = {}, action) {
  switch (action.type) {
    case entityActions.ENTITIES_ADDED:
      return {
        ...state,
        [action.resource]: entityResource(state[[action.resource]], action)
      };
    default:
      return state;
  }
}

export const getOrders = (state, orderIds) => {
  return orderIds.map(orderId => state.orders[orderId]);
};

export const getOrder = (state, orderId) => {
  return state.orders && state.orders[orderId];
};



// WEBPACK FOOTER //
// ./src/reducers/entitiesReducer.js